import React from "react";
import formImage from "../../assets/images/png/formImage.png";

const CMYuvaFormPart1 = ({ register, errors }) => {
  return (
    <div className="row g-0 h-100">
      {/* Left Side: Form Inputs */}
      <div className="col-12 col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-center">
        <div className="mb-4">
          <h3 className="fw-bold mb-1">Personal Details</h3>
          <p className="text-gray-300 small">Please enter your details exactly as they appear on your ID.</p>
        </div>

        {/* 1. Full Name */}
        <div className="mb-3">
          <label className="form-label small fw-bold text-gray-300 text-uppercase">1. Full Name</label>
          <input
            type="text"
            className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.fullName ? "is-invalid" : ""}`}
            placeholder="e.g. Amit Kumar"
            {...register("fullName", { required: "Full name is required" })}
          />
          {errors.fullName && <div className="invalid-feedback">{errors.fullName.message}</div>}
        </div>

        {/* 2. Email */}
        <div className="mb-3">
          <label className="form-label small fw-bold text-gray-300 text-uppercase">2. Email Address</label>
          <input
            type="email"
            className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.email ? "is-invalid" : ""}`}
            placeholder="name@example.com"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Enter a valid email address",
              },
            })}
          />
          {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
        </div>

        {/* 3. Contact Number */}
        <div className="mb-3">
          <label className="form-label small fw-bold text-gray-300 text-uppercase">3. Contact Number</label>
          <div className="input-group">
            <span className="input-group-text backdrop-blur-md bg-white/[0.03] border border-white/10 text-gray-300 fw-bold border-end-0">+91</span>
            <input
              type="tel"
              className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.contactNumber ? "is-invalid" : ""}`}
              placeholder="9999999999"
              maxLength="10"
              {...register("contactNumber", {
                required: "Contact Number is required",
                pattern: {
                  value: /^[6-9]\d{9}$/,
                  message: "Valid 10-digit Indian mobile number required",
                },
              })}
            />
            {errors.contactNumber && <div className="invalid-feedback d-block">{errors.contactNumber.message}</div>}
          </div>
        </div>
      </div>

      {/* Right Side: Image (Hidden on Mobile) */}
      <div className="col-lg-5 d-none d-lg-block bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a] position-relative overflow-hidden">
        <img
          src={formImage}
          alt="Illustration"
          className="w-100 h-100 object-fit-cover position-absolute top-0 start-0"
        />
        {/* Optional Overlay Text */}
        <div className="position-absolute bottom-0 start-0 w-100 p-4 text-white" style={{background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'}}>
           <small className="fw-bold opacity-75">STEP 1</small>
           <h5 className="mb-0">Start Your Journey</h5>
        </div>
      </div>
    </div>
  );
};

export default CMYuvaFormPart1;
